import { useEffect } from "react";

/** The browser tab reads `<title> · TrueReel` while the page is mounted and
 *  goes back to what it was when the page is left. Nothing is set while
 *  `title` is null (the page is still loading). `jobs/notify.ts` marks the
 *  tab on top of whatever this sets and restores it itself. */
export function useDocumentTitle(title: string | null) {
  useEffect(() => {
    if (title === null) return;
    const before = document.title;
    document.title = `${title} · TrueReel`;
    return () => {
      document.title = before;
    };
  }, [title]);
}
